import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'dark' | 'light';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'invento-theme';
  currentTheme = signal<Theme>('light');

  constructor() {
    effect(() => {
      this.applyTheme(this.currentTheme());
      localStorage.setItem(this.STORAGE_KEY, this.currentTheme());
    });
  }

  init(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY) as Theme | null;
    // Default to light for new users; returning users keep their saved choice.
    this.currentTheme.set(saved ?? 'light');
    this.applyTheme(this.currentTheme());
  }

  toggle(): void {
    this.currentTheme.update((t) => (t === 'dark' ? 'light' : 'dark'));
  }

  private applyTheme(theme: Theme): void {
    document.documentElement.setAttribute('data-theme', theme);
  }
}
